const zh = {
  lead: "家庭、徒步者、滑雪者和游客步行、滑雪、乘船追寻巨魔。把巨魔放在你门口，寻宝游戏就会把新客人直接带到你这里——无论你经营的是什么地方。",
  areasKicker: "行业",
  areasTitle: "找到你的行业。",
  bannerKicker: "你在这个行业经营企业吗？",
  bannerTitle: "获得更多客户，吸引新游客。",
  cta: "成为 Trollfossjakten 合作伙伴",
  placesLike: "适合的地方",
  ideaTitle: "巨魔创意",
  cats: {
    hotels: {
      name: "酒店与连锁酒店",
      short: "把寻宝者变成住宿客人。",
      lead: "在入口、花园或酒店自己的小径上放一个巨魔，让家庭有理由留宿一晚——并在下个季节再来。",
      idea: "一个在门口帮忙提行李的搬运巨魔，一个守在早餐自助窗边的早餐巨魔，以及一个在屋顶露台北极光下的夜巨魔。",
      types: ["连锁酒店", "历史酒店", "峡湾与山地酒店", "度假村与水疗酒店", "沿海酒店", "木屋与山舍"],
    },
    restaurants: {
      name: "餐厅与连锁咖啡馆",
      short: "饥饿的寻宝者，就在你门口。",
      lead: "寻找巨魔会让人饿。在你的餐厅放上巨魔，让玩家在路上用 Vipps 预订并付款。",
      idea: "一个搅汤的厨师巨魔，一个在露台上的披萨巨魔，以及一个守护最佳靠窗座位的咖啡巨魔。",
      types: ["披萨与汉堡连锁", "咖啡连锁", "牛排馆", "家庭餐厅", "寿司与亚洲餐厅", "连锁面包店"],
    },
    activities: {
      name: "活动与体验",
      short: "给冒险者再多一个预订的理由。",
      lead: "峡湾游、漂流、探险之旅和导览徒步都是巨魔的绝佳领地。你的巨魔把一次旅行变成一次任务——并把玩家带到你的预订柜台。",
      idea: "皮划艇码头边穿救生衣的巨魔，冰川上的冰川巨魔，以及只在冬季极光之旅中现身的极光巨魔。",
      types: ["峡湾游与游船", "沿海航线", "漂流与皮划艇", "北极与极光之旅", "探险旅行", "荒野中心"],
    },
    ski: {
      name: "滑雪场与山地目的地",
      short: "整个冬天，雪道上都有巨魔。",
      lead: "缆车旁、越野雪道上和山顶咖啡馆里的巨魔让每个滑雪日都变成一场寻宝——也让家庭在夏季再次回来。",
      idea: "缆车旁踩着老式木雪板的滑雪巨魔，林间雪道上的雪巨魔，以及在山顶端上热可可的山顶巨魔。",
      types: ["高山滑雪场", "越野滑雪中心", "山村", "夏季滑雪", "滑雪后派对与山舍", "滑雪学校"],
    },
    attractions: {
      name: "景点与博物馆",
      short: "让巨魔讲述你的故事。",
      lead: "巨魔本就属于挪威民间传说。把它们放进你的博物馆园区、木板教堂旁或著名徒步路线上，游客会停留更久、探索更多。",
      idea: "老农舍旁讲故事的巨魔，木板教堂上的龙头巨魔，以及守护观景点的悬崖巨魔。",
      types: ["露天博物馆", "船舶与历史博物馆", "艺术博物馆", "木板教堂与大教堂", "国家公园", "著名徒步路线与观景点"],
    },
    transport: {
      name: "交通与渡轮",
      short: "让旅程成为寻宝的一部分。",
      lead: "渡轮、快艇、巴士和火车每天载着成千上万好奇的旅客。船上和码头的巨魔把等待时间变成游戏时间。",
      idea: "在渡轮船头挥手的海巨魔，巴士站的检票巨魔，以及只能在火车上遇到的隧道巨魔。",
      types: ["渡轮公司", "快艇", "区域巴士", "火车", "城市公交", "码头与客运站"],
    },
    cafes: {
      name: "咖啡馆与面包店",
      short: "新鲜面包、热咖啡——门口还有一个巨魔。",
      lead: "咖啡馆外的一个巨魔就能把玩家吸引进来喝咖啡、吃华夫饼和肉桂卷。他们可以用 Vipps 预订，到店即取。",
      idea: "鼻子上沾着面粉的面包师巨魔，正隔着窗户闻肉桂卷的香味。",
      types: ["本地咖啡馆", "面包店", "咖啡烘焙坊", "面包与咖啡连锁分店", "冰淇淋亭", "华夫饼小屋"],
    },
    saunas: {
      name: "桑拿",
      short: "寻宝之后，暖暖身子。",
      lead: "在步道上度过寒冷的一天后，没有什么比峡湾边的桑拿更舒服。桑拿巨魔把玩家带到你门口，他们还能用 Vipps 预约时段。",
      idea: "一个裹着条纹毛巾的快乐巨魔，在平台上冒着热气，怂恿大家跳进峡湾。",
      types: ["本地桑拿", "漂浮桑拿", "峡湾桑拿", "桑拿俱乐部", "水疗与浴场", "户外热水桶"],
    },
    shops: {
      name: "小店与本地生产者",
      short: "小小店铺，大大发现。",
      lead: "寻宝者喜欢带点东西回家。你店门口的一个巨魔，就能让每个路过的人在地图上看到你。",
      idea: "一个提着满篮果酱、奶酪和羊毛袜的店主巨魔。",
      types: ["农场商店", "纪念品与手工艺店", "啤酒厂与酿酒厂", "钓具与户外用品店", "书店与礼品店", "超市、体育与五金店"],
    },
  },
};

export default zh;
